import { render } from "./notificationIcon.svg?vue&type=template&id=5524571e"
const script = {}
script.render = render

export default script